import { Box, Grid, Typography } from "@mui/material";
import { ReactChildren } from "../../interfaces/Common";

const AuthLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        sm={6}
        sx={{
          display: { xs: 'none', sm: 'block' },
          position: 'relative',
          overflow: 'hidden',
          background: 'linear-gradient(180deg, #8FC7EE 0%, #5FA8E0 42%, #2E82C4 100%)',
        }}
      >
        <Box component="svg" width="120" height="40" viewBox="0 0 120 40" fill="none" stroke="#eaf4fd" strokeWidth="2" strokeLinecap="round"
          sx={{ position: 'absolute', top: '12%', left: '10%', opacity: 0.7 }}
        >
          <path d="M6 14c3-4 5-4 8 0 3-4 5-4 8 0" />
          <path d="M40 8c3-4 5-4 8 0 3-4 5-4 8 0" />
          <path d="M22 26c2-3 4-3 6 0 2-3 4-3 6 0" />
        </Box>
        <Box component="svg" viewBox="0 0 600 320" preserveAspectRatio="xMidYMax slice" fill="none"
          sx={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', display: 'block' }}
        >
          <g fill="#eef6fd" opacity="0.25">
            <rect x="30" y="180" width="60" height="140" />
            <rect x="510" y="200" width="60" height="120" />
          </g>
          <g fill="#ffffff" opacity="0.9">
            <path d="M210 320V96c0-30 30-46 90-46s90 16 90 46v224z" />
          </g>
          <g fill="#cfe6f8">
            <rect x="228" y="120" width="8" height="180" />
            <rect x="248" y="120" width="8" height="180" />
            <rect x="268" y="120" width="8" height="180" />
            <rect x="288" y="120" width="8" height="180" />
            <rect x="308" y="120" width="8" height="180" />
            <rect x="328" y="120" width="8" height="180" />
            <rect x="348" y="120" width="8" height="180" />
            <rect x="368" y="120" width="8" height="180" />
          </g>
          <rect x="250" y="86" width="100" height="16" rx="4" fill="#14285C" opacity="0.85" />
          <g fill="#dcedfb">
            <path d="M120 320V150c0-16 14-26 44-26s44 10 44 26v170z" />
            <path d="M392 320V160c0-16 14-24 42-24s42 8 42 24v160z" />
          </g>
          <path d="M0 300c60-16 120-16 180 0s120 20 220 4 140-14 200 6v10H0z" fill="#2E82C4" opacity="0.5" />
        </Box>
        <Box sx={{ position: 'absolute', left: '34px', bottom: '30px', color: '#fff' }}>
          <Typography sx={{ fontWeight: 800, fontSize: '20px', letterSpacing: '0.3px', textShadow: '0 2px 12px rgba(0,40,80,.35)' }}>
            Transforming Lives
          </Typography>
          <Typography sx={{ fontSize: '12px', opacity: 0.92, marginTop: '4px' }}>
            Through Skilling &middot; L&amp;T CTT Campus
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#EEF1F7',
          maxHeight: '100vh',
          overflowY: 'auto',
          padding: '24px 0',
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
